import { Dispatch, SetStateAction, useState } from 'react'
import { deepCopy } from '@/utils'

// A page's edits over a stored setting. Each new stored value (the first load, the reload after a
// save) replaces them; the copy keeps edits made in place out of the query cache.
export function useSettingsDraft<T>(
  stored: T | undefined,
  empty: T
): [T, Dispatch<SetStateAction<T>>] {
  const [draft, setDraft] = useState<T>(() => deepCopy(stored ?? empty))
  const [seen, setSeen] = useState(stored)
  // Synced while rendering, not in an effect, so no frame shows new stored values beside old edits.
  if (stored !== seen) {
    setSeen(stored)
    if (stored !== undefined) setDraft(deepCopy(stored))
  }
  return [draft, setDraft]
}
